const Integrations = () => {
  return <h1>Integrations</h1>;
};
export default Integrations;
